"use client";

import Link from "next/link";
import { registerPaths } from "routes";

import Icon from "@/components/atoms/Icon";
import Sprite from "@/components/atoms/Sprite";
import { useTranslation } from "@/i18n/client";
import type { AllowedLanguages } from "@/types/generic";

interface RegisterSectionProps {
  locale: AllowedLanguages;
}

export const RegisterSection = ({ locale }: RegisterSectionProps) => {
  const { t } = useTranslation(locale);

  return (
    <div className="relative col-span-12 overflow-hidden bg-yellow-600 p-8 text-center md:col-span-4 lg:p-12 lg:pt-24">
      <div className="relative z-1">
        <h4>{t("pages.myvivaldis_login.register_section.title")}</h4>
        <div className="mb-7 text-black-400">
          {t("pages.myvivaldis_login.register_section.description")}
        </div>
        <Link
          href={`/${locale}/myvivaldis/${registerPaths[locale]}`}
          className="btn btn-white"
        >
          {t("pages.myvivaldis_login.register_section.registration_link")}
        </Link>
        <hr className="my-8 border-t-yellow-300 lg:my-14" />
        <div className="text-left text-sm">
          <div className="mb-7 text-black-400">
            {t("pages.myvivaldis_login.register_section.usps_title")}
          </div>
          <ul className="flex flex-col gap-3">
            <li className="flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-yellow">
                <Icon name="coffee" className="h-6 w-6" />
              </div>
              <span className="text-black-400">
                {t("pages.myvivaldis_login.register_section.usp_1")}
              </span>
            </li>
            <li className="flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-yellow">
                <Icon name="coin" className="h-6 w-6" />
              </div>
              <span className="text-black-400">
                {t("pages.myvivaldis_login.register_section.usp_2")}
              </span>
            </li>
            <li className="flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-yellow">
                <Icon name="flag" className="h-6 w-6" />
              </div>
              <span className="text-black-400">
                {t("pages.myvivaldis_login.register_section.usp_3")}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <Sprite className="right-0 top-[-80px] w-[480px] translate-x-[120px]" />
    </div>
  );
};
